import { useState } from 'react';
import SearchInput from '@rossum/components/search-input/SearchInput';
import { FilterComponentProps } from '../types';
import { FilterComponentWrapper } from './FilterComponentWrapper';
import { SelectOptionsSkeleton } from './SelectComponents';
import { useFilterSelectProps } from './useFilterSelectProps';

export const FilterMultiSelect = <T extends number[] | string[] | undefined>({
  filterKey,
  name,
  options,
  currentValue,
  confirmFilter,
  onBackClick,
  onClose,
  optionsAreLoading,
  getOptionLabel = o => o,
}: FilterComponentProps<T>) => {
  const [searchValue, setSearchValue] = useState('');

  const currentValueString = currentValue?.map(c => c.toString());

  const { ListComponent, selectedValues } = useFilterSelectProps({
    options,
    getOptionLabel,
    currentValues: currentValueString ?? [],
    searchValue,
    isSingleSelect: false,
  });

  return (
    <FilterComponentWrapper
      filterKey={filterKey}
      name={name}
      onSubmit={() => {
        if (selectedValues && selectedValues.length) {
          confirmFilter(selectedValues as T);
          onClose();
        }
      }}
      onBackClick={onBackClick}
      onClose={onClose}
      isSubmitDisabled={!!optionsAreLoading}
      maxWidth={500}
    >
      <SearchInput
        onChange={setSearchValue}
        value={searchValue}
        withStartAdornment={false}
        sx={{ width: '100%' }}
        autoFocus
      />
      {optionsAreLoading ? <SelectOptionsSkeleton /> : ListComponent}
    </FilterComponentWrapper>
  );
};
